module.exports = __webpack_public_path__ + "img/schema-hero-infra.bd6f139c.png";